/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { CouponApi } from "@/apis/clients";
import { wrap } from "@/apis/wrap";

const couponApi = {
  postCouponAvailability: wrap(
    CouponApi,
    CouponApi.prototype.postCouponAvailability,
  ),
  postCouponValidate: wrap(CouponApi, CouponApi.prototype.postCouponValidate),
};

export default couponApi;
